export enum ModalName {
  AddRating = 'AddRating',
  ProblemNotSolved = 'ProblemNotSolved',
  FeedbackCompleted = 'FeedbackCompleted'
}
